export const ROOT = "/";
export const ABOUT = "/about";
export const PROJECTS = "/projects"
// export const PROJECT_DETAILS = `${ PROJECTS }/:id`;
export const VACANCIES = "/vacancies";
export const VACANCY_DETAILS = `${ VACANCIES }/:id`;
export const CONTACTS = "/contacts";
export const AUTOMATION = "/automation";
export const COMMISSIONING_WORKS = "/commissioning_works";